export const ProductPageLang = {
    OUR_COLLECTION: "Our Collection",
    PRODUCT_DESC: 'Each of these tiles has its own unique designs and patterns. We understand the need for a diverse collection, as no flower in a garden is the same. Every customer has their own character and qualities, which they would like to showcase in their homes.',
    
    COLLECTION: "COLLECTION",
    PRODUCT_1:"400x400mm Digital Parking Tiles",
    PRODUCT_2:"500x500mm Digital Parking Tiles",
};